import { match } from 'ts-pattern'

import {
  isNumber,
  isPositiveNumber,
  percentage,
  required
} from '@sequencehq/utils/validation'
import { RateDisplay } from 'Invoices/types'

export const quantityValidators = [required, isPositiveNumber]

export const getRateValidators = (rateDisplay: RateDisplay) => [
  required,
  ...match(rateDisplay)
    .with('ABSOLUTE', () => [isNumber])
    .with('PERCENTAGE', () => [percentage, isPositiveNumber])
    .exhaustive()
]
